/**
 * This browser's (or app install's) stable device id, `malka_device_id`.
 *
 * The queue socket authenticates with it, and the room-token mint sends it so
 * the server can tell the device holding an account's call from a second
 * device of the same account. (The retired room pill, vrs-room-controls.js,
 * opened a second socket with ':room-controls' appended; the server still
 * understands that suffix for pages cached before 2026-09-24.) Kept dependency-free (storage only) so
 * the room-token helper can use it without pulling in the queue client.
 */
import { getPersistentItem, setPersistentItem } from '../vrs-auth/storage';
export const HANDOFF_DEVICE_ID_STORAGE_KEY = 'malka_device_id';
export function getHandoffDeviceId() {
    let id = getPersistentItem(HANDOFF_DEVICE_ID_STORAGE_KEY);
    if (!id) {
        id = `device-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
        setPersistentItem(HANDOFF_DEVICE_ID_STORAGE_KEY, id);
    }
    return id;
}
